var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardAvgReturns(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FFF3EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 35H34",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 21.3809H17C16.45 21.3809 16 21.8309 16 22.3809V31.0009C16 31.5509 16.45 32.0009 17 32.0009H18.6C19.15 32.0009 19.6 31.5509 19.6 31.0009V22.3809C19.6 21.8309 19.15 21.3809 18.6 21.3809Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8002 18.1895H24.2002C23.6502 18.1895 23.2002 18.6395 23.2002 19.1895V30.9995C23.2002 31.5495 23.6502 31.9995 24.2002 31.9995H25.8002C26.3502 31.9995 26.8002 31.5495 26.8002 30.9995V19.1895C26.8002 18.6395 26.3502 18.1895 25.8002 18.1895Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 15H31.4004C30.8504 15 30.4004 15.45 30.4004 16V31C30.4004 31.55 30.8504 32 31.4004 32H33.0004C33.5504 32 34.0004 31.55 34.0004 31V16C34.0004 15.45 33.5504 15 33.0004 15Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAvgReturns);
export default __webpack_public_path__ + "static/media/dashboard-avg-returns.a8d594689dc5d42bd735732005c461fa.svg";
export { ForwardRef as ReactComponent };